import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { ProductRequest, ProductRequestCommentRequest, ProductRequestQueueService } from 'src/app/Services/product-request-queue.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { ArtistProductSummary } from 'src/app/Services/artistproducts.service';
import { NotificationTypes } from 'src/app/app.enums';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { TranslocoService } from '@jsverse/transloco';
import { ArtworkCardSize, ArtworkStatusTone } from 'src/app/common/ds-artwork-card/ds-artwork-card.component';
@Component({
    selector: 'artist-product-tile',
    templateUrl: './artist-product-tile.component.html',
    inputs: ['product'],
    providers: [ProductRequestQueueService],
    standalone: false
})
export class ArtistProductTileComponent implements OnInit {
    public product!: ArtistProductSummary;
    @Input() size: ArtworkCardSize = 'md';
    @Input() requestedProducts: ProductRequest[] = [];

    public get statusLabel(): string {
        if (this.product?.IsSold) { return this.transloco.translate('artistProductTile.sold'); }
        if (this.product?.IsConsignedProduct) { return this.transloco.translate('artistProductTile.consigned'); }
        return this.transloco.translate('artistProductTile.available');
    }
    public get statusTone(): ArtworkStatusTone {
        if (this.product?.IsSold) { return 'sold'; }
        if (this.product?.IsConsignedProduct) { return 'consigned'; }
        return 'available';
    }
    public get displayPrice(): number | null {
        if (this.product?.IsSold) { return this.product?.SoldPrice ?? null; }
        return this.product?.ArtistRevenue ?? null;
    }
    public get isAvailable(): boolean {
        return !!this.product && !this.product.IsConsignedProduct && !this.product.IsSold;
    }
    public authConfig!: AuthConfig;
    public galleryId!: string;
    public formData: ProductRequestCommentRequest = {} as ProductRequestCommentRequest;
    public showCommentDialog: boolean = false;
    public selectedProductRequest!: ArtistProductSummary;
    public displayEmojiDialog: boolean = false;

    public ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        if (this.authConfig.IsGallery) {
            this.galleryId = this.authService.getUserId();
              if (this.requestedProducts && this.product) {
            const isProductRequested = this.requestedProducts.some(
                requestedProduct => requestedProduct.ArtistProductId === this.product.Id
            );
            this.product.requestSent = isProductRequested;
        }
    }
}
    

    constructor(private authService: AuthService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private notificationsService: NotificationsService,
        private productRequestQueueService: ProductRequestQueueService,
        private ngxSpinnerService: NgxSpinnerService,
        private transloco: TranslocoService) {

    }

    private getAllProductRequests() {
        this.ngxSpinnerService.show();
        this.productRequestQueueService.getAllProductRequests().subscribe((artistProducts) => {
            this.requestedProducts = artistProducts;
            console.log('artistProducts')
            // Check if the current product ID exists in the list of requested products
            const isProductRequested = this.requestedProducts.some(requestedProduct => requestedProduct.ArtistProductId === this.product.Id);

            if (isProductRequested) {
                this.product.requestSent = true;
            }
            //  console.log('this.requestedProducts', this.requestedProducts);
            this.ngxSpinnerService.hide();
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
    }

    public sendProductRequestDialog(product: ArtistProductSummary) {
        console.log(product);
        this.selectedProductRequest = product;
        this.showCommentDialog = true;
    }

    public sendProductRequest() {
        this.ngxSpinnerService.show();
        var requestData = new ProductRequest();
        requestData.ArtistId = this.selectedProductRequest.ArtistId;
        requestData.ArtistProductId = this.selectedProductRequest.Id;

        this.productRequestQueueService.sendProductRequest(this.selectedProductRequest.Id, this.formData).subscribe((response) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
                this.selectedProductRequest.requestSent = true;
                this.selectedProductRequest.buttonColorClass = 'p-button-success';
                this.showCommentDialog = false;
                this.formData = new ProductRequestCommentRequest();
                this.notificationsService.showNotification(this.transloco.translate('artistProductTile.success'), this.transloco.translate('artistProductTile.productRequestSent'), NotificationTypes.Success);
            } else { console.error(response); this.notificationsService.showNotification(this.transloco.translate('artistProductTile.error'), this.transloco.translate('artistProductTile.processingError'), NotificationTypes.Error); }
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
    }


    public openEmojiDialog() {
        this.displayEmojiDialog = !this.displayEmojiDialog;
    }

    public addEmoji(emoji: string) {
        console.log('Selected emoji:', emoji);
        this.formData.ProductRequestComment = (this.formData.ProductRequestComment || '') + emoji;
        this.displayEmojiDialog = false;
    }

    public closeEmojiDialog($event: any) {
        this.displayEmojiDialog = false;
    }

    public goToProductDetails(product: ArtistProductSummary) {
        this.router.navigate(['/', product.ArtistId, 'artworks', product.Id]);
    }

    public onCloseDialog() {
        this.showCommentDialog = false;
        this.formData = new ProductRequestCommentRequest();
    }
}